/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_SpinnerInputs */

const en_loading_spinner = /** @type {(inputs: Loading_SpinnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const nl_loading_spinner = /** @type {(inputs: Loading_SpinnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden...`)
};

/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Loading_SpinnerInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const loading_spinner = /** @type {((inputs?: Loading_SpinnerInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_SpinnerInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_loading_spinner(inputs)
	return en_loading_spinner(inputs)
});